import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import { DatePicker, Select, Spin, Tooltip, Input, Drawer } from "antd";

import CommonFooter from "../../../../../../core/common/footer/commonFooter";
// import { Edit, Eye, Trash2 } from "feather-icons-react/build/IconComponents";
// import { Edit } from "feather-icons-react/build/IconComponents";
import dayjs from "dayjs";
import Swal from "sweetalert2";
import { BASE_CRM_URL } from "../../../../../components/config/config";
// import { all_routes } from "../../../../../../Router/all_routes";
import PropTypes from "prop-types";
import { CalendarOutlined } from "@ant-design/icons";
import Table from "../../../../../../core/pagination/datatable";

const RemaindersTab = ({ CustomerData }) => {
  // const route = all_routes;
  // const { id } = useParams();

  const customerId = CustomerData?.customerId;
  const userDetails = JSON.parse(sessionStorage.getItem("userDetails"));
  const userId = userDetails?.staffid;

  const [addReminderOpen, setAddReminderOpen] = useState(false);
  const [editReminderOpen, setEditReminderOpen] = useState(false);

  const columns = [
    {
      title: "Description",
      dataIndex: "description",
      sorter: (a, b) => a.description.localeCompare(b.description),
      render: (text) => (
        <Tooltip title={text}>
          <div className="text-truncate" style={{ maxWidth: 260 }}>
            {text}
          </div>
        </Tooltip>
      ),
    },

    // {
    //   title: "Date",
    //   dataIndex: "date",
    //   sorter: (a, b) =>
    //     dayjs(a.date, "DD/MM/YYYY").unix() - dayjs(b.date, "DD/MM/YYYY").unix(),

    //   render: (_, record) => (
    //     <div className="d-flex align-items-start">
    //       <i className="fa-regular fa-calendar-days text-primary me-2 mt-1"></i>

    //       <div>
    //         <div className="fw-semibold">{record.date}</div>
    //         <small className="text-muted">
    //           <i className="fa-regular fa-clock text-danger me-1"></i>
    //           {record.time}
    //         </small>
    //       </div>
    //     </div>
    //   ),
    // },
    // {
    //   title: "Date",
    //   dataIndex: "date",

    //   sorter: (a, b) =>
    //     dayjs(a.date).unix() - dayjs(b.date).unix(),

    //   render: (_, record) => (
    //     <div className="d-flex align-items-start">
    //       <i className="fa-regular fa-calendar-days text-primary me-2 mt-1"></i>

    //       <div>
    //         <div className="fw-semibold">
    //           {record.date
    //             ? dayjs(record.date).format("DD-MM-YYYY")
    //             : "-"}
    //         </div>

    //         <small className="text-muted">
    //           <i className="fa-regular fa-clock text-danger me-1"></i>
    //           {record.date
    //             ? dayjs(record.date).format("hh:mm A")
    //             : "-"}
    //         </small>
    //       </div>
    //     </div>
    //   ),
    // },
    {
      title: "Date",
      dataIndex: "date",
      sorter: (a, b) => dayjs(a.date).unix() - dayjs(b.date).unix(),

      render: (date) => (
        <>
          <i className="fa-regular fa-calendar-days text-primary me-2"></i>
          {date ? dayjs(date).format("DD-MM-YYYY") : "-"}
        </>
      ),
    },

    {
      title: "Time",
      dataIndex: "date",

      render: (date) => (
        <>
          <i className="fa-regular fa-clock text-danger me-2"></i>
          {date ? dayjs(date).format("hh:mm A") : "-"}
        </>
      ),
    },

    {
      title: "Remind",
      dataIndex: "remind",
      sorter: (a, b) =>
        `${a.firstname} ${a.lastname}`.localeCompare(
          `${b.firstname} ${b.lastname}`,
        ),

      render: (_, record) => {
        const firstname = record.firstname || "";
        const lastname = record.lastname || "";

        const fullName = `${firstname} ${lastname}`.trim();

        // const initials = `${firstname.charAt(0)}${lastname.charAt(
        //   0,
        // )}`.toUpperCase();

        return (
          <div className="d-flex align-items-center">
            {/* <div
              className="rounded-circle bg-soft-info text-black d-flex align-items-center justify-content-center me-2"
              style={{
                width: 34,
                height: 34,
                fontSize: 13,
                fontWeight: 600,
              }}
            >
              {initials}
            </div> */}

            <span>{fullName || "-"}</span>
          </div>
        );
      },
    },

    {
      title: "Status",
      dataIndex: "isnotified",
      key: "isnotified",

      sorter: (a, b) => Number(a.isnotified) - Number(b.isnotified),

      filters: [
        {
          text: "Completed",
          value: 1,
        },
        {
          text: "Pending",
          value: 0,
        },
      ],

      onFilter: (value, record) => Number(record.isnotified) === Number(value),

      render: (status, record) => {
        const isCompleted = Number(status) === 1;

        return (
          <Select
            value={isCompleted ? 1 : 0}
            onChange={(value) => handleChange(value, record)}
            style={{
              width: 120,
            }}
            options={[
              {
                value: 1,
                label: (
                  <span
                    style={{
                      color: "#198754",
                      fontWeight: 600,
                    }}
                  >
                    ● Completed
                  </span>
                ),
              },
              {
                value: 0,
                label: (
                  <span
                    style={{
                      color: "#dc3545",
                      fontWeight: 600,
                    }}
                  >
                    ● Pending
                  </span>
                ),
              },
            ]}
          />
        );
      },
    },
    {
      title: "Action",
      dataIndex: "action",
      align: "center",

      render: (_, record) => (
        <>
          {/* <Link className="action-set" to="#" data-bs-toggle="dropdown">
            <i className="fa fa-ellipsis-v btn border"></i>
          </Link>

          <ul className="dropdown-menu">
            <li>
              <Link
                to="#"
                className="dropdown-item"
                onClick={() => {
                  handleEditReminder(record);
                  setEditReminderOpen(true);
                }}
              >
                <Edit className="me-2 text-secondary" />
                Edit
              </Link>
            </li>
          </ul> */}

          <div className="action-table-data">
            <div className="edit-delete-action ">
              <Link
                to="#"
                className="me-2 p-2  shadow-sm"
                onClick={() => {
                  handleEditReminder(record);
                  setEditReminderOpen(true);
                }}
              >
                <i className="ti ti-pencil text-primary"></i>
              </Link>
              <Link
                to="#"
                className="me-2 p-2  shadow-sm"
                onClick={() => handleDeleteReminder(record.id)}
              >
                <i className="ti ti-trash text-danger"></i>
              </Link>
            </div>
          </div>
        </>
      ),
    },
  ];

  const [reminders, setReminders] = useState([]);
  const [remindersLoading, setRemindersLoading] = useState(false);

  const [addReminderLoading, setAddReminderLoading] = useState(false);
  const [updateReminderLoading, setUpdateReminderLoading] = useState(false);

  const [editingReminderId, setEditingReminderId] = useState(null);

  const [reminderData, setReminderData] = useState({
    description: "",
    date: null,
    staff: null,
  });

  const [editReminderData, setEditReminderData] = useState({
    description: "",
    date: null,
    staff: null,
    isNotified: null,
  });

  const [staffList, setStaffList] = useState([]);
  const [staffLoading, setStaffLoading] = useState(false);
  const [selectedStaff, setSelectedStaff] = useState([]);

  const fetchReminders = async () => {
    try {
      setRemindersLoading(true);

      const response = await fetch(
        `${BASE_CRM_URL}reminder/GetReminders?rel_id=${customerId}&rel_type=customer&staffid=0`,
      );

      const data = await response.json();

      if (data.Status) {
        setReminders(data.ResultData || []);
      } else {
        setReminders([]);
      }
    } catch (error) {
      console.error(error);
      setReminders([]);
    } finally {
      setRemindersLoading(false);
    }
  };

  const fetchStaff = async () => {
    try {
      setStaffLoading(true);

      const response = await fetch(`${BASE_CRM_URL}staff/GetStaffDropdown`);
      const data = await response.json();

      if (data.ResultData) {
        setStaffList(data.ResultData);
      } else {
        setStaffList([]);
      }
    } catch (error) {
      console.error("Error fetching staff:", error);
      setStaffList([]);
    } finally {
      setStaffLoading(false);
    }
  };

  const handleAddReminder = async () => {
    if (!reminderData.description.trim()) {
      Swal.fire({
        icon: "warning",
        title: "Description Required",
        text: "Please enter reminder description.",
      });
      return;
    }

    if (!reminderData.date) {
      Swal.fire({
        icon: "warning",
        title: "Reminder Date Required",
        text: "Please select reminder date.",
      });
      return;
    }

    try {
      setAddReminderLoading(true);
      const userDetails = JSON.parse(sessionStorage.getItem("userDetails"));
      const userId = userDetails?.staffid;
      const response = await fetch(`${BASE_CRM_URL}reminder/AddReminder`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          description: reminderData.description,
          date: dayjs(reminderData.date).format("YYYY-MM-DD HH:mm:ss"),
          rel_id: customerId,
          rel_type: "customer",
          staff: selectedStaff,
          creator: userId,
        }),
      });

      const data = await response.json();
      setAddReminderLoading(false);

      if (data.Status) {
        await Swal.fire({
          icon: "success",
          title: "Success",
          text: data.Message,
          timer: 1500,
          showConfirmButton: false,
        });

        setReminderData({
          description: "",
          date: null,
          staff: userId,
        });

        setSelectedStaff([]);

        setAddReminderOpen(false);
       
        window.dispatchEvent(new Event("refresh-notifications"));
        

        await fetchReminders();
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: data.Message,
        });
      }
    } catch (error) {
      console.error(error);

      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Something went wrong.",
      });
    } finally {
      setAddReminderLoading(false);
    }
  };

  const handleEditReminder = (reminder) => {
    setEditingReminderId(reminder.id);

    setEditReminderData({
      description: reminder.description,
      date: dayjs(reminder.date),
      staff: reminder.staff,
      isNotified: reminder.isnotified,
    });
  };

  const handleCancelReminderEdit = () => {
    setEditingReminderId(null);

    setEditReminderData({
      description: "",
      date: null,
      staff: userId,
    });
    setEditReminderOpen(false);
  };

  const handleUpdateReminder = async () => {
    if (!editReminderData.description.trim()) {
      Swal.fire({
        icon: "warning",
        title: "Description Required",
        text: "Please enter reminder description.",
      });
      return;
    }

    try {
      setUpdateReminderLoading(true);

      const response = await fetch(`${BASE_CRM_URL}reminder/UpdateReminder`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: editingReminderId,
          description: editReminderData.description,
          date: dayjs(editReminderData.date).format("YYYY-MM-DD HH:mm:ss"),
          staff: editReminderData.staff,
          isnotified: editReminderData.isNotified,
        }),
      });

      const data = await response.json();
      setUpdateReminderLoading(false);

      if (data.Status) {
        await Swal.fire({
          icon: "success",
          title: "Updated",
          text: data.Message,
          timer: 1500,
          showConfirmButton: false,
        });

        setEditingReminderId(null);

        setEditReminderData({
          description: "",
          date: null,
          staff: userId,
        });

        setEditReminderOpen(false);

        await fetchReminders();
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: data.Message,
        });
      }
    } catch (error) {
      console.error(error);

      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Something went wrong.",
      });
    } finally {
      setUpdateReminderLoading(false);
    }
  };

  useEffect(() => {
    fetchReminders();
    fetchStaff();
  }, []);

  const handleCloseAddReminder = () => {
    setAddReminderOpen(false);
  };

  const handleChange = async (value, record) => {
    try {
      const response = await fetch(
        `${BASE_CRM_URL}reminder/UpdateReminderNotification`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            id: record.id,
            isnotified: Number(value),
          }),
        },
      );

      const result = await response.json();

      if (!response.ok || !result?.Status) {
        throw new Error(result?.Message || "Failed to update status");
      }

      Swal.fire({
        icon: "success",
        title: "Status Updated",
        text: result?.Message || "Reminder status updated successfully.",
        timer: 1200,
        showConfirmButton: false,
      });

      fetchReminders();
    } catch (error) {
      console.error("Update status error:", error);

      Swal.fire({
        icon: "error",
        title: "Update Failed",
        text: error.message || "Unable to update reminder status.",
      });
    }
  };

  const handleDeleteReminder = async (id) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "Do you want to delete this reminder?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#e40d22",
      cancelButtonColor: "#6c757d",
      confirmButtonText: "Yes, delete it!",
    });

    if (!result.isConfirmed) return;

    try {
      const response = await fetch(`${BASE_CRM_URL}reminder/DeleteReminder`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: id,
        }),
      });

      const data = await response.json();

      if (data.Status || data.status) {
        Swal.fire({
          icon: "success",
          title: "Deleted!",
          text: data.message || "Reminder deleted successfully.",
          timer: 1500,
          showConfirmButton: false,
        });

        fetchReminders();
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: data.message || "Failed to delete reminder.",
        });
      }
    } catch (error) {
      console.error("Delete reminder error:", error);

      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Something went wrong while deleting the reminder.",
      });
    }
  };

  return (
    <>
      {(addReminderLoading || updateReminderLoading) && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
          style={{
            zIndex: 99999,
            backdropFilter: "blur(4px)",
            backgroundColor: "rgba(255, 255, 255, 0.2)",
          }}
        >
          <Spin size="large" tip="Processing..." />
        </div>
      )}
      <div>
        <div className="card table-list-card ">
          <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
            <div className="search-set p-3"></div>
            <div className="d-flex table-dropdown my-xl-auto right-content align-items-center flex-wrap row-gap-3">
              {/* <div className="me-3">
          <Select
            defaultValue="2026"
            style={{ width: 120 ,height: 34}}
            options={[
              { value: "2026", label: "2026" },
              { value: "2025", label: "2025" },
              { value: "2024", label: "2024" },
            ]}
          />
          </div> */}

              <div className="page-btn">
                <Link
                  to="#"
                  className="btn btn-success btn-sm me-2"
                  onClick={() => setAddReminderOpen(true)}
                >
                  <i className="ti ti-circle-plus fs-4 "> </i>
                </Link>
              </div>
            </div>
          </div>

          <div className="card-body">
            <div className=" table-responsive">
              {remindersLoading ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "250px", // adjust height if needed
                  }}
                >
                  <Spin size="large" />
                </div>
              ) : (
                <Table columns={columns} dataSource={reminders} />
              )}
            </div>
          </div>
        </div>

        <CommonFooter />
      </div>

      <style>
        {`
        @media (max-width: 576px) {
          #offcanvasAddReminder {
            width: 90% !important;
          }
        }

        @media (min-width: 577px) and (max-width: 992px) {
          #offcanvasAddReminder {
            width: 60% !important;
          }
        }

        @media (min-width: 993px) and (max-width: 1440px) {
          #offcanvasAddReminder {
            width: 30% !important;
          }
        }
          
        @media (min-width: 1441px)  {
          #offcanvasAddReminder {
            width: 23% !important;
          }
        }






        @media (max-width: 576px) {
          #offcanvasEditReminder {
            width: 90% !important;
          }
        }

        @media (min-width: 577px) and (max-width: 992px) {
          #offcanvasEditReminder {
            width: 60% !important;
          }
        }

        @media (min-width: 993px) and (max-width: 1440px) {
          #offcanvasEditReminder {
            width: 30% !important;
          }
        }
          
        @media (min-width: 1441px)  {
          #offcanvasEditReminder {
            width: 23% !important;
          }
        }
        `}
      </style>

      <Drawer
        title="Add New Reminder"
        placement="right"
        width={450}
        onClose={handleCloseAddReminder}
        open={addReminderOpen}
        closable={false}
        destroyOnClose
        extra={
          <>
            {/* <Button
              type="text"
              icon={<CloseOutlined />}
              onClick={() => setOpenAddContact(false)}
            /> */}

            <div className="d-flex justify-content-end gap-2">
              {/* <Button type="text" icon={<CloseOutlined />} onClick={onClose} /> */}

              <button
                type="button"
                onClick={handleCloseAddReminder}
                disabled={addReminderLoading}
                className="btn rounded-circle d-flex align-items-center justify-content-center shadow-sm"
                style={{
                  width: "35px",
                  height: "35px",
                  backgroundColor: "#e40d22",
                  color: "#fff",
                  border: "none",
                }}
                title="Close"
              >
                <i className="fa fa-times" />
              </button>

              <button
                type="button"
                onClick={handleAddReminder}
                disabled={addReminderLoading}
                className="btn rounded-circle d-flex align-items-center justify-content-center shadow-sm"
                style={{
                  width: "35px",
                  height: "35px",
                  backgroundColor: "#07f083",
                  color: "#fff",
                  border: "none",
                }}
                title="Save"
              >
                {addReminderLoading ? (
                  <span
                    className="spinner-border spinner-border-sm"
                    role="status"
                  />
                ) : (
                  <i className="fa fa-check" />
                )}
              </button>
            </div>
          </>
        }
      >
        <form>
          <div className="row">
            {/* Date To Be Notified */}
            <div className="col-12 mb-3">
              <label className="form-label">
                <span className="text-danger">*</span> Date To Be Notified
              </label>

              <DatePicker
                showTime
                className="w-100"
                style={{ height: 38 }}
                value={reminderData.date}
                onChange={(value) =>
                  setReminderData((prev) => ({
                    ...prev,
                    date: value,
                  }))
                }
                suffixIcon={<CalendarOutlined />}
              />
            </div>

            {/* Reminder To */}
            <div className="col-12 mb-3">
              <label className="form-label">
                <span className="text-danger">*</span> Reminder To
              </label>

              <Select
                mode="multiple"
                className="w-100"
                style={{ height: 38 }}
                loading={staffLoading}
                placeholder="Select Staff"
                value={selectedStaff}
                onChange={setSelectedStaff}
                options={staffList.map((staff) => ({
                  value: staff.staffid,
                  label: `${staff.firstname} ${staff.lastname}`,
                }))}
              />
            </div>

            {/* Description */}
            <div className="col-12 mb-3">
              <label className="form-label">Description</label>

              <Input.TextArea
                rows={4}
                placeholder="Reminder description"
                value={reminderData.description}
                onChange={(e) =>
                  setReminderData((prev) => ({
                    ...prev,
                    description: e.target.value,
                  }))
                }
              />
            </div>
          </div>

          {/* Footer */}
          {/* <div className="d-flex justify-content-end gap-2">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={handleCloseAddReminder}
            >
              Close
            </button>

            <button
              type="button"
              className="btn btn-primary"
              onClick={handleAddReminder}
              disabled={addReminderLoading}
            >
              {addReminderLoading ? "Adding..." : "Add"}
            </button>
          </div> */}
        </form>
      </Drawer>

      <Drawer
        title="Edit Reminder"
        placement="right"
        width={450}
        onClose={handleCancelReminderEdit}
        open={editReminderOpen}
        destroyOnClose
        closable={false}
        extra={
          <>
            {/* <Button
              type="text"
              icon={<CloseOutlined />}
              onClick={() => setOpenAddContact(false)}
            /> */}

            <div className="d-flex justify-content-end gap-2">
              {/* <Button type="text" icon={<CloseOutlined />} onClick={onClose} /> */}

              <button
                type="button"
                onClick={handleCancelReminderEdit}
                disabled={updateReminderLoading}
                className="btn rounded-circle d-flex align-items-center justify-content-center shadow-sm"
                style={{
                  width: "35px",
                  height: "35px",
                  backgroundColor: "#e40d22",
                  color: "#fff",
                  border: "none",
                }}
                title="Close"
              >
                <i className="fa fa-times" />
              </button>

              <button
                type="button"
                onClick={handleUpdateReminder}
                disabled={updateReminderLoading}
                className="btn rounded-circle d-flex align-items-center justify-content-center shadow-sm"
                style={{
                  width: "35px",
                  height: "35px",
                  backgroundColor: "#07f083",
                  color: "#fff",
                  border: "none",
                }}
                title="Save"
              >
                {updateReminderLoading ? (
                  <span
                    className="spinner-border spinner-border-sm"
                    role="status"
                  />
                ) : (
                  <i className="fa fa-check" />
                )}
              </button>
            </div>
          </>
        }
      >
        <form>
          <div className="row">
            {/* Date */}
            <div className="col-12 mb-3">
              <label className="form-label">
                <span className="text-danger">*</span> Date
              </label>

              <DatePicker
                showTime
                className="w-100"
                style={{ height: 38 }}
                value={editReminderData.date}
                onChange={(value) =>
                  setEditReminderData((prev) => ({
                    ...prev,
                    date: value,
                  }))
                }
                suffixIcon={<CalendarOutlined />}
              />
            </div>

            {/* Reminder To */}
            <div className="col-12 mb-3">
              <label className="form-label">
                <span className="text-danger">*</span> Reminder To
              </label>

              <Select
                className="w-100"
                style={{ height: 38 }}
                placeholder="Select Staff"
                value={editReminderData.staff}
                onChange={(value) =>
                  setEditReminderData((prev) => ({
                    ...prev,
                    staff: value,
                  }))
                }
                options={staffList.map((staff) => ({
                  value: staff.staffid,
                  label: `${staff.firstname} ${staff.lastname}`,
                }))}
              />
            </div>

            {/* Description */}
            <div className="col-12 mb-3">
              <label className="form-label">Description</label>

              <Input.TextArea
                rows={4}
                value={editReminderData.description}
                onChange={(e) =>
                  setEditReminderData((prev) => ({
                    ...prev,
                    description: e.target.value,
                  }))
                }
              />
            </div>
          </div>

          {/* Footer */}
          {/* <div className="d-flex justify-content-end gap-2">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={handleCancelReminderEdit}
            >
              Cancel
            </button>

            <button
              type="button"
              className="btn btn-primary"
              onClick={handleUpdateReminder}
              disabled={updateReminderLoading}
            >
              {updateReminderLoading ? "Updating..." : "Update"}
            </button>
          </div> */}
        </form>
      </Drawer>
    </>
  );
};

RemaindersTab.propTypes = {
  CustomerData: PropTypes.object,
};

export default RemaindersTab;
